import styled from "styled-components";

export const Container = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.white};
`;